<div class="wrapper">
    <ion-icon src="../../../../../assets/icon/card.svg"></ion-icon>
    <p class="title">Bestelling betaald?</p>
    <p class="content">Deze bestelling is mogelijks nog niet betaald, zeker dat jij deze levering wil eindigen?</p>
    <ion-button class="primary" (click)="confirmPayment()">
        Bestelling is betaald
    </ion-button>
    <ion-button class="cancel" fill="clear" (click)="close()">Annuleer</ion-button>
</div>